import { Clock, Users, MapPin } from "lucide-react";
import { Reveal } from "./Motion";

const STATS = [
  { icon: Clock, value: "+24h", line1: "de conteúdo", line2: "prático" },
  { icon: Users, value: "+10k", line1: "servidores já", line2: "participaram" },
  { icon: MapPin, value: "+20", line1: "estados", line2: "presentes" },
];

export default function StatsBar() {
  return (
    <div className="relative py-14 sm:py-20 bg-gradient-to-b from-brand-royal/25 via-brand-elev/30 to-brand-base border-y border-white/10" data-testid="stats-bar">
      <div className="absolute inset-0 bg-[radial-gradient(700px_300px_at_50%_50%,rgba(0,142,255,0.10),transparent_70%)] pointer-events-none" />
      <div className="relative max-w-5xl mx-auto px-5 sm:px-8">
        <div className="grid grid-cols-3">
          {STATS.map((s, i) => (
            <Reveal key={s.value} delay={0.1 * i} className="h-full">
              <div
                className={`flex flex-col items-center text-center gap-3 sm:gap-4 px-2 sm:px-8 ${
                  i > 0 ? "border-l border-white/10" : ""
                }`}
                data-testid={`stat-${i}`}
              >
                <s.icon size={30} strokeWidth={1.4} className="text-brand-cyan" />
                <div className="flex items-center gap-3">
                  <span className="font-display font-extrabold text-white text-3xl sm:text-5xl tracking-tight leading-none">
                    {s.value}
                  </span>
                  <span className="text-left text-white/70 text-[11px] sm:text-base leading-snug">
                    {s.line1}
                    <br />
                    {s.line2}
                  </span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
